module.exports = __webpack_public_path__ + "static/media/casino_mob_slide.8381be96.jpeg";